import { ArrowRightIcon } from '@heroicons/react/24/outline';

export default function ChartSection() {
  return (
    <div className="flex justify-center mb-16">
      <div className="bg-white rounded-xl shadow-lg p-6 max-w-2xl w-full">
        <h3 className="text-lg font-semibold text-primary mb-4 text-center">View Real-Time Charts & Trading Data</h3>
        <a
          href="https://dexscreener.com/solana/6es1g7jpwrrem6phit5ge4fzzduwvwt6hzd4jpn7vzsp"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cta inline-flex items-center justify-center px-6 py-3 text-lg group w-full"
          aria-label="View RENT token price charts and trading data on DexScreener"
          data-tracking="cta-click"
          data-tracking-location="chart-section"
          data-tracking-destination="dexscreener"
        >
          View on DexScreener
          <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </div>
  );
}